angular.module('articles_factories').factory('ArticlesReportFactory', ['$resource', function ($resource) {
    return $resource('/api/v2.0/articles/articlesreport/:report_slug/', {report_slug: '@report_slug'}, {
        get: {
            method: 'GET',
            isArray: true
        }
    });
}]);